<template>
    <div>
        <div class="modal is-active" v-show="showDeleteModal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Delete Pull out to client info</p>
                    <button class="delete" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    Are you sure do you want to delete this?
                </section>
                <footer class="modal-card-foot" style="justify-content:flex-end">
                    <button :class="dangerButton" @click="deleteUser">Delete permanently</button>
                    <button class="button is-small" @click="closeModal">Cancel</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      dangerButton: appButton.isLoadingDanger(false)
    }
  },
  computed: {
    ...mapState('pullouttoclient', {
      showDeleteModal: state => state.showDeleteModal,
      pullOutToClient: state => state.pullOutToClient
    })
  },
  methods: {
    ...mapActions('pullouttoclient', ['openDeleteModal', 'getPaginatedPullOutToClients']),
    deleteUser() {
      this.dangerButton = appButton.isLoadingDanger(true)
      axios
        .delete(`api/pullouttoclients/${this.pullOutToClient.pullOutToClientId}`)
        .then(response => {
          appToast.success(response.data)
          this.default()
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            appToast.danger(error.response.data)
          }
        })
        .then(() => {
          this.dangerButton = appButton.isLoadingDanger(false)
        })
    },
    closeModal() {
      this.default()
    },
    default() {
      this.openDeleteModal({
        showDeleteModal: false
      })
      this.getPaginatedPullOutToClients({
        page: 1,
        pageSize: 10,
        query: ''
      })
    }
  }
}
</script>
